<template>
    <div v-if="show" class="swal-overlay" :class="{ 'swal-overlay--show-modal': show }" @click="$emit('cancel')">
      <div class="swal-modal custom-swal2" @click.stop>
        <div class="swal-content" style="margin-bottom:50px;padding: 0 20px;">
          <slot name="content"></slot>
        </div>
        <div class="swal-content full-footer" style="padding:0px !important; text-align:center;margin-bottom:10px;">
          <div class="swal-footer d-flex justify-content-center custom-modal-footer full">
            <button
              class="btn text-white btn-sm rounded mx-1 font-14 font-bold custom-blue-bg w-230"
              style="width:260px !important;font-size:18px; font-weight: 600;"
              @click="$emit('cancel')"
            >
              {{ cancelText }}
            </button>
            <button
              class="btn text-white btn-sm rounded mx-2 font-8 text-center custom-red-bg w-230"
              style="width:260px !important; font-size:8px;font-weight: 600"
              @click="$emit('confirm')"
            >
              <slot name="confirm-text"></slot>
            </button>
          </div>
        </div>
        <div class="swal-footer mobile-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm custom-red-bg"
              style="border-radius:3px"
              @click="$emit('confirm')"
            >
              <slot name="confirm-text-mobile"></slot>
            </button>
            <div class="swal-button__loader">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--cancel custom-blue-bg"
              @click="$emit('cancel')"
              style="font-weight: bold;"
            >
              {{ cancelText }}
            </button>
            <div class="swal-button__loader">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ConfirmationModal',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      cancelText: {
        type: String,
        default: 'キャンセル'
      }
    }
  }
  </script>
  <style scoped>
  .custom-swal2 {
    background: rgb(223, 235, 255); 
    max-width: 600px; 
    padding-top: 80px
  }

  .mobile-footer {
    display: none;
  }

  @media (max-width: 767px) {
    .mobile-footer {
      display: block;
    }

    .full-footer {
      display: none;
    }
  }
  </style>